import React, { Component } from 'react';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { MyContext, MyGlobal, MyHeading, MyAlert } from '../../GlobalContext';
import * as MySound from '../../MySound';

export class AdhocCount_Location extends Component {
    static displayName = AdhocCount_Location.name;

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            alertMessage: "",
            selectedStocktake:"",
            selectedLocationBarcode: "",
            selectedLocationId: "",
            previouspage: props.location.state.previouspage

        };
        this.history = props.history;
    }

    componentDidMount() {


        if (!MyGlobal.selected_stocktake) {
            this.clearAll("Please select a Stocktake");
            return;
        }

        var selectedStocktakeParsedData = JSON.parse(MyGlobal.selected_stocktake);
        if (selectedStocktakeParsedData) {
            this.state.selectedStocktake = selectedStocktakeParsedData;
        }
        
        if (!this.state.selectedStocktake.stocktakeId || this.state.selectedStocktake.stocktakeId === "")
        {
            this.clearAll("Please select a Stocktake");
            return;
        }
        this.refs.locationInput.focus();
    }
    goto(page) {
        this.history.push({
            pathname: page,
            state: {
                selectedLocationId: this.state.selectedLocationId,
                previouspage: this.state.previouspage
            }
        });
    }

    gotoPreviousPage() {
        switch (this.state.previouspage) {
            case "Recount_ConfirmLocation":
                this.goto("../Recount/Recount_ConfirmLocation");
                break;
            case "FirstCount_ConfirmLocation":
                this.goto("../FirstCount/FirstCount_ConfirmLocation");
                break;
            default:
                this.goto("../StocktakeTasks");
        }
    }


    async getLocationId() {
        this.state.loading = true;
        var warehouseID = MyGlobal.warehouse;
        fetch(`api/Stocktake/GetLocationIdByLocationBarcode?stocktakeId=${this.state.selectedStocktake.stocktakeId.trim()}&locationBarcode=${this.state.selectedLocationBarcode.trim()}&warehouseID=${warehouseID}`)
            .then(async response => {

                this.state.loading = false;
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    this.setState({ alertMessage: "Failed to get Location Id!!" + errorText });
                }
                else {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const apiResponse = isJson ? await response.json() : null;


                    if (apiResponse) {
                        const matchingLocations = apiResponse.data;
       
                        if (apiResponse.success) {

                            if (matchingLocations.length === 0) {
                                this.setState({ alertMessage: "Location not found in client warehouse!" });
                                MySound.play(MySound.Sound.stop);
                                return;
                            }
                            if (matchingLocations.length > 1) {
                                this.setState({ alertMessage: "Error multiple locations found!" });
                                MySound.play(MySound.Sound.stop);
                                return;
                            }
                            if (matchingLocations.length === 1) {

                                var matchingLocation = matchingLocations[0];
                                this.setState({ selectedLocationId: matchingLocation.loc_ID });
                                this.goto('AdhocCount_ProductSelect');
                            }

                        }
                        else {
                            this.setState({ selectedLocationId: "", alertMessage: "Failed to get Location Id!!  " + apiResponse.errorMessage });
                        }
                    }
                    else {
                        this.setState({ selectedLocationId: "", alertMessage: "Failed to get Location Id!!" });
                    }
                }

            })
            .catch(error => {
                this.setState({ selectedLocationId: "", alertMessage: error });
            });
    }

    clearAll(message) {
        this.setState({
            alertMessage: message,
            loading: false,
            selectedLocationBarcode: "",
            selectedLocationId: ""
   
        });
    }

    validateLocation() {
        if (this.state.selectedLocationBarcode == "") {

            this.clearAll("Enter a valid Location");
            MySound.play(MySound.Sound.stop);
            return;
        }

        this.state.selectedLocationBarcode = this.state.selectedLocationBarcode.trim();

        MyGlobal.isStockCounted = "false";
        this.getLocationId();

    }
    render() {

        const handleNextBtnClick = e => {
            this.validateLocation();
        };

        const handleLocationKeyPress = e => {

            if (e.keyCode === 13 || e.charCode === 13 || e.which === 13) {
                this.validateLocation();
            }

        };

       
        let alertMessage = this.state.alertMessage;
        alertMessage = alertMessage != "" ? <MyAlert variant="danger">{alertMessage}</MyAlert> : "";

        return (
            <div>
                <Container>
                    <Row className="mb-3">
                        <Col xs={9}><h5>Adhoc Count - Enter Location</h5></Col>
                        <Col xs={3}><button type="button" className="btn btn-success col-12 mb-2" onClick={() => { this.gotoPreviousPage(); }} >
                            Back
                        </button></Col>
                    </Row>
                    <Row className="mb-3">
                        <Col>{alertMessage}</Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={12}>
                            <input ref="locationInput" className="form-control" value={this.state.selectedLocationBarcode} onKeyPress={handleLocationKeyPress}
                                onChange={(e) => {
                                    this.setState({ selectedLocationBarcode: e.target.value });
                                }} >
                            </input>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={12}>
                            <button type="button" className="btn btn-success col-12 mb-2" onClick={handleNextBtnClick}>Next</button>
                        </Col>
                    </Row>
                </Container>
            </div>

        );
    }


}
